module.exports = "/_next/static/images/a2203bec5199c79719654051647c7a16-left-side-mobile.jpg";